// extracted by mini-css-extract-plugin
export default {"captiv8Link":"KeyDeals_captiv8Link__O5Z5i","no-deals":"KeyDeals_no-deals__CJFia"};